import {productListInformation} from '@data/fragments/products/__generated__/productListInformation'
import classnames from '@helpers/misc/classnames'
import SelectPriceForProduct from '@helpers/misc/selectPriceForProduct'
import PRICING_TYPES from '@page-components/Order/CategoryPage/Content/Products/ProductCard/pricingTypes'
import truncate from 'lodash/truncate'
import {useTranslation} from 'next-i18next'
export interface Props {
  product: productListInformation
  disabledProduct: boolean
  reverse: boolean
}
function Badge(props: Props) {
  const {t} = useTranslation('website', {
    keyPrefix: 'order.products.productsContent.category.product.cards.rowProduct'
  })
  const {product, disabledProduct, reverse} = props
  if (disabledProduct) {
    const disabledMessage = !product.availabilityAt?.available
      ? product.availabilityAt?.notAvailableMessage ?? t('labelUnavailable')
      : t('labelOutOfStock')
    return (
      <span
        className={classnames(
          'absolute top-2 items-center rounded-3xl bg-black px-1.5 py-0.5 text-sm font-bold text-white',
          {
            'right-2': reverse,
            'left-2': !reverse
          }
        )}>
        {truncate(disabledMessage, {length: 16})}
      </span>
    )
  }

  const pricing = SelectPriceForProduct(product)
  return (
    <>
      {pricing?.type === PRICING_TYPES.discount && (
        <span
          className={classnames(
            'absolute top-2 items-center rounded-3xl bg-violet-100 px-1.5 py-0.5 text-sm font-bold text-violet-700 ring-1 ring-inset ring-indigo-700/10',
            {
              'right-2': reverse,
              'left-2': !reverse
            }
          )}>
          -{Math.round((1 - pricing.price / pricing.oldPrice) * 100)}%
        </span>
      )}
    </>
  )
}

export default Badge
